import { displayCurrentLevel } from './membership-level-groups';
import { AmountSelection } from '../../../modules/amount-selection';
// Custom amount checkbox used by multiple things
export const customAmountInput = document.querySelector('#Amounts_custom-field') as HTMLInputElement;
export const invalidAmountError = document.querySelector('[data-amount-invalid-error]') as HTMLElement;

const handleCustomAmountInput = () => {
    const newValue = parseInt(customAmountInput.value);
    if (isNaN(newValue) || newValue < 0) {
        customAmountInput.value = '0';
        invalidAmountError.removeAttribute('hidden');
    }
    else {
        invalidAmountError.setAttribute('hidden', '');
    }
    displayCurrentLevel(newValue);
}

export const initializeAmounts = () => {
    if (customAmountInput) {
        customAmountInput.addEventListener('blur', handleCustomAmountInput);

        // if custom amount is pre-populated from query string, update membership level immediately
        if (parseInt(customAmountInput.value) > 0) {
            handleCustomAmountInput();
        }

        const donationAmountsList = document.querySelector('#Donation_amounts');
        if (donationAmountsList) {
            const allRadios = [].slice.call(donationAmountsList.querySelectorAll('input[type="radio"]'));
            const customAmountRadio = document.querySelector('#Amounts_custom') as HTMLInputElement;
            new AmountSelection(customAmountInput, allRadios, customAmountRadio);
        }
    }
}